import { ArrowRight } from "lucide-react";
import { BOOKING_URL } from "@/data/content";

// SimplePractice widget attributes (from the embed snippet Joannie provided).
// When present and the SP integration script has loaded, clicking the link
// opens the booking modal in-page instead of a new tab.
export const SP_WIDGET_ATTRS = {
  "data-spwidget-scope-id": "8dd0885f-1cc0-49e8-badc-adf12b4ddb4e",
  "data-spwidget-scope-uri": "joannie-campuzano-cepeda",
  "data-spwidget-application-id":
    "7c72cb9f9a9b913654bb89d6c7b4e71a77911b30192051da35384b4d0c6d505b",
  "data-spwidget-type": "OAR",
  "data-spwidget-scope-global": "",
  "data-spwidget-autobind": "",
};

/**
 * Reusable booking CTA backed by the SimplePractice widget.
 * Falls back to opening the booking URL in a new tab if the SP script hasn't
 * loaded yet — so the link always works.
 */
export default function BookingButton({
  label = "Book a session",
  variant = "primary",
  size = "md",
  testid = "booking-btn",
  className = "",
}) {
  const sizes = {
    sm: "px-5 py-2.5 text-xs",
    md: "px-7 py-3.5 text-sm",
    lg: "px-9 py-4 text-base",
  };
  const styles = {
    primary: {
      background: "var(--sano-olive)",
      color: "var(--sano-bg)",
      border: "1px solid var(--sano-olive)",
    },
    ghost: {
      background: "transparent",
      color: "var(--sano-ink)",
      border: "1px solid var(--sano-ink)",
    },
    light: {
      background: "var(--sano-bg)",
      color: "var(--sano-olive)",
      border: "1px solid var(--sano-bg)",
    },
  };

  return (
    <a
      href={BOOKING_URL}
      target="_blank"
      rel="noreferrer"
      {...SP_WIDGET_ATTRS}
      className={`group inline-flex items-center gap-3 rounded-full font-medium transition-all hover:scale-[1.02] ${sizes[size]} ${className}`}
      style={styles[variant]}
      data-testid={testid}
    >
      {label}
      <ArrowRight
        size={size === "lg" ? 18 : 16}
        strokeWidth={1.5}
        className="transition-transform group-hover:translate-x-1"
      />
    </a>
  );
}
